(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    class CartDrawer extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.cart-drawer__panel');
        this.closing = false;

        this.addEventListener('click', (event) => this.handleClick(event));
        this.addEventListener('change', (event) => {
          const input = event.target.closest('[data-line-quantity]');
          if (input) this.change(input.closest('[data-key]').dataset.key, input.value);
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });

        // The header's cart link opens the drawer instead of navigating away
        // (except on the cart page itself, where it's already open in full).
        this.onDocumentClick = (event) => {
          const link = event.target.closest('[data-cart-link]');
          if (!link || event.defaultPrevented) return;
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

          const strip = (path) => path.replace(/\/$/, '');
          if (strip(new URL(link.href, window.location.origin).pathname) === strip(window.location.pathname)) return;

          event.preventDefault();
          this.open();
          this.refresh();
        };
        document.addEventListener('click', this.onDocumentClick);

        // Fired by the full cart page after it changes a line.
        this.onCartUpdated = () => this.refresh();
        document.addEventListener('cart:updated', this.onCartUpdated);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('cart:updated', this.onCartUpdated);
      }

      handleClick(event) {
        if (event.target.closest('[data-drawer-close]')) {
          this.close();
          return;
        }

        const row = event.target.closest('[data-key]');
        if (!row) return;
        const key = row.dataset.key;
        const input = row.querySelector('[data-line-quantity]');
        const current = parseInt(input?.value, 10) || 0;

        if (event.target.closest('[data-line-decrease]')) this.change(key, Math.max(0, current - 1));
        if (event.target.closest('[data-line-increase]')) this.change(key, current + 1);
        if (event.target.closest('[data-line-remove]')) this.change(key, 0);
      }

      open() {
        this.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => this.classList.add('cart-drawer--open'));
        this.panel?.focus();
      }

      close() {
        if (this.closing) return;
        this.closing = true;
        this.classList.remove('cart-drawer--open');
        document.body.style.overflow = '';

        const finish = () => {
          this.hidden = true;
          this.closing = false;
          this.panel?.removeEventListener('transitionend', finish);
        };

        this.panel?.addEventListener('transitionend', finish);
        setTimeout(finish, 450);
      }

      async change(key, quantity) {
        this.classList.add('cart-drawer--loading');
        try {
          await fetch(this.dataset.changeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) || 0 }),
          });
        } finally {
          await this.refresh();
          this.classList.remove('cart-drawer--loading');
        }
      }

      async refresh() {
        try {
          const response = await fetch(this.dataset.rootUrl + '?section_id=' + this.dataset.sectionId);
          if (!response.ok) return;

          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('[data-drawer-content]');
          const current = this.querySelector('[data-drawer-content]');
          if (!incoming || !current) return;

          current.replaceWith(incoming);
          this.updateHeaderCount(parseInt(incoming.dataset.itemCount, 10) || 0);
        } catch (error) {
          // Leave the existing contents in place if the refresh fails.
        }
      }

      updateHeaderCount(count) {
        document.querySelectorAll('[data-cart-link]').forEach((link) => {
          const text = (link.dataset.countTemplate || '').replace('__COUNT__', count);
          if (text) link.setAttribute('aria-label', text);

          const label = link.querySelector('.site-header__cart-label');
          if (label && text) label.textContent = text;

          const icon = link.querySelector('.site-header__cart-icon');
          let badge = link.querySelector('.site-header__cart-badge');
          if (count > 0 && icon) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'site-header__cart-badge';
              icon.appendChild(badge);
            }
            badge.textContent = count;
          } else if (badge) {
            badge.remove();
          }
        });
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  if (!customElements.get('cart-items')) {
    class CartItems extends HTMLElement {
      connectedCallback() {
        this.updateUrl = this.dataset.cartUpdateUrl;
        this.subtotalEl = document.querySelector('[data-cart-subtotal]');

        this.querySelectorAll('[data-cart-decrease]').forEach((button) => {
          button.addEventListener('click', () => this.step(button, -1));
        });
        this.querySelectorAll('[data-cart-increase]').forEach((button) => {
          button.addEventListener('click', () => this.step(button, 1));
        });
        this.querySelectorAll('[data-cart-quantity]').forEach((input) => {
          input.addEventListener('change', () => this.setQuantity(input.dataset.key, input.value, input));
        });
        this.querySelectorAll('[data-cart-remove]').forEach((button) => {
          button.addEventListener('click', () => this.setQuantity(button.dataset.key, 0, button));
        });
      }

      step(button, delta) {
        const row = button.closest('[data-cart-item]');
        const input = row.querySelector('[data-cart-quantity]');
        const next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        this.setQuantity(input.dataset.key, next, input);
      }

      async setQuantity(key, quantity, sourceEl) {
        const row = sourceEl.closest('[data-cart-item]');
        row.style.opacity = '0.5';

        try {
          const response = await fetch(this.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) || 0 }),
          });

          if (!response.ok) throw new Error('Cart update failed');
          const cart = await response.json();

          if (parseInt(quantity, 10) === 0) {
            row.remove();
          } else {
            const updatedItem = cart.items.find((item) => item.key === key);
            const lineTotal = row.querySelector('[data-item-line-total]');
            if (updatedItem && lineTotal) {
              lineTotal.textContent = this.formatMoney(updatedItem.final_line_price);
            }
          }

          if (this.subtotalEl) {
            this.subtotalEl.textContent = this.formatMoney(cart.total_price);
          }

          if (cart.item_count === 0) {
            window.location.reload();
          }

          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          row.style.opacity = '';
        } finally {
          row.style.opacity = '';
        }
      }

      formatMoney(cents) {
        return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
    }

    customElements.define('cart-items', CartItems);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  if (!customElements.get('collection-sort')) {
    class CollectionSort extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        this.select?.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', this.select.value);
          window.location.href = url.toString();
        });
      }
    }

    customElements.define('collection-sort', CollectionSort);
  }

  if (!customElements.get('collection-grid')) {
    class CollectionGrid extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-grid]');
        this.progressLabel = this.querySelector('[data-progress-label]');
        this.progressFill = this.querySelector('[data-progress-fill]');
        this.loadMoreButton = this.querySelector('[data-load-more]');
        this.loadMoreButton?.addEventListener('click', () => this.loadMore());
      }

      async loadMore() {
        const button = this.loadMoreButton;
        const url = button?.getAttribute('data-next-url');
        if (!button || !url) return;

        button.disabled = true;
        button.textContent = button.dataset.loadingLabel;

        try {
          const separator = url.includes('?') ? '&' : '?';
          const response = await fetch(url + separator + 'section_id=' + this.dataset.sectionId);
          if (!response.ok) throw new Error('Failed to load more products');

          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newGrid = doc.querySelector('[data-grid]');
          if (newGrid && this.grid) {
            Array.from(newGrid.children).forEach((card) => this.grid.appendChild(card));
          }

          const newLabel = doc.querySelector('[data-progress-label]');
          if (newLabel && this.progressLabel) this.progressLabel.textContent = newLabel.textContent;

          const newFill = doc.querySelector('[data-progress-fill]');
          if (newFill && this.progressFill) this.progressFill.style.width = newFill.style.width;

          const newButton = doc.querySelector('[data-load-more]');
          if (newButton) {
            button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
            button.disabled = false;
            button.textContent = button.dataset.idleLabel;
          } else {
            button.remove();
          }
        } catch (error) {
          button.disabled = false;
          button.textContent = button.dataset.idleLabel;
        }
      }
    }

    customElements.define('collection-grid', CollectionGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('nav-drawer')) {
    class NavDrawer extends HTMLElement {
      connectedCallback() {
        this.trigger = document.querySelector('[aria-controls="' + this.id + '"]');
        this.panel = this.querySelector('.nav-drawer__panel');
        this.views = Array.from(this.querySelectorAll('[data-drawer-view]'));
        this.closing = false;

        this.trigger?.addEventListener('click', () => this.open());
        this.querySelectorAll('[data-drawer-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        this.querySelectorAll('[data-drawer-goto]').forEach((el) => {
          el.addEventListener('click', () => this.goto(el.getAttribute('data-drawer-goto')));
        });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
      }

      open() {
        this.hidden = false;
        this.trigger?.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => this.classList.add('nav-drawer--open'));
        this.panel?.focus();
      }

      close() {
        if (this.closing) return;
        this.closing = true;
        this.classList.remove('nav-drawer--open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';

        const finish = () => {
          this.hidden = true;
          this.goto('root');
          this.closing = false;
          this.panel?.removeEventListener('transitionend', finish);
        };

        this.panel?.addEventListener('transitionend', finish);
        setTimeout(finish, 450);
      }

      goto(view) {
        this.views.forEach((el) => {
          el.hidden = el.getAttribute('data-drawer-view') !== view;
        });
        this.panel?.scrollTo?.({ top: 0 });
      }
    }

    customElements.define('nav-drawer', NavDrawer);
  }

  if (!customElements.get('site-header')) {
    class SiteHeader extends HTMLElement {
      connectedCallback() {
        this.updateHeight();
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      updateHeight() {
        document.documentElement.style.setProperty('--header-height', this.offsetHeight + 'px');
      }
    }

    customElements.define('site-header', SiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slideCopies = Array.from(this.querySelectorAll('[data-slide-copy]'));
        this.slideImages = Array.from(this.querySelectorAll('[data-slide-image]'));
        this.slideInsets = Array.from(this.querySelectorAll('[data-slide-inset]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
        this.indexEl = this.querySelector('[data-hero-index]');
        this.captionEl = this.querySelector('[data-slide-inset-caption]');
        this.headings = this.slideCopies.map((el) => el.querySelector('.hero__heading'));

        const script = this.querySelector('[data-hero-captions]');
        this.captions = script ? JSON.parse(script.textContent) : [];

        this.total = this.slideCopies.length;
        this.current = 0;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.current - 1));
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.current + 1));
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));

        if (this.dataset.autoplay === 'true' && this.total > 1) {
          this.startAutoplay();
          this.addEventListener('mouseenter', () => this.stopAutoplay());
          this.addEventListener('mouseleave', () => this.startAutoplay());
        }

        this.revealHeading(this.headings[0]);
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      revealHeading(headingEl, attempt) {
        attempt = attempt || 0;
        if (!headingEl || this.reduceMotion) return;
        if (!window.gsap) {
          if (attempt > 40) return;
          setTimeout(() => this.revealHeading(headingEl, attempt + 1), 100);
          return;
        }

        const gsap = window.gsap;
        if (this.activeSplit && this.activeSplit.revert) {
          try {
            this.activeSplit.revert();
          } catch (e) {
            // ignore, we're about to replace it anyway
          }
        }

        if (window.SplitText) {
          try {
            this.activeSplit = new window.SplitText(headingEl, { type: 'lines', mask: 'lines' });
            gsap.from(this.activeSplit.lines, {
              yPercent: 116,
              duration: 1.15,
              ease: 'power4.out',
              stagger: 0.09,
            });
            return;
          } catch (e) {
            // fall through to the plain fade below
          }
        }

        gsap.from(headingEl, { opacity: 0, y: 30, duration: 1, ease: 'power3.out' });
      }

      startAutoplay() {
        this.stopAutoplay();
        const speed = parseInt(this.dataset.autoplaySpeed, 10) || 7000;
        this.timer = setInterval(() => this.go(this.current + 1), speed);
      }

      stopAutoplay() {
        clearInterval(this.timer);
      }

      go(index) {
        const next = (index + this.total) % this.total;
        if (next === this.current) return;
        this.current = next;

        this.slideCopies.forEach((el, i) => el.classList.toggle('hero__slide-copy--active', i === next));
        this.slideImages.forEach((el, i) => el.classList.toggle('hero__frame-slide--active', i === next));
        this.slideInsets.forEach((el, i) => el.classList.toggle('hero__inset-slide--active', i === next));
        this.dots.forEach((el, i) => el.classList.toggle('hero__dot--active', i === next));
        this.revealHeading(this.headings[next]);

        if (this.indexEl) {
          this.indexEl.textContent = '0' + (next + 1) + ' / 0' + this.total;
        }

        if (this.captionEl && this.captions[next]) {
          const kicker = this.captionEl.querySelector('.hero__inset-kicker');
          const heading = this.captionEl.querySelector('.hero__inset-heading');
          if (kicker) kicker.textContent = this.captions[next].label || '';
          if (heading) heading.textContent = this.captions[next].heading || '';
        }
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;

        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const inner = doc.querySelector('[data-recommendations-inner]');
            if (inner) this.innerHTML = inner.outerHTML;
          })
          .catch(() => {
            // Leave the section empty rather than showing broken markup.
          });
      }
    }

    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-gallery')) {
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => this.show(thumb.getAttribute('data-media-id')));
        });
      }

      show(mediaId) {
        this.thumbs.forEach((thumb) => {
          thumb.classList.toggle('product-gallery__thumb--active', thumb.getAttribute('data-media-id') === mediaId);
        });
        this.slides.forEach((slide) => {
          slide.classList.toggle('product-gallery__slide--active', slide.getAttribute('data-media-id') === mediaId);
        });
      }
    }

    customElements.define('product-gallery', ProductGallery);
  }

  if (!customElements.get('product-info')) {
    class ProductInfo extends HTMLElement {
      connectedCallback() {
        const script = this.querySelector('[data-product-variants]');
        this.variants = script ? JSON.parse(script.textContent) : [];
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.gallery = document.getElementById(this.dataset.galleryId);

        this.optionButtons = Array.from(this.querySelectorAll('[data-option-position]'));
        this.variantIdInput = this.querySelector('[data-variant-id-input]');
        this.priceCurrent = this.querySelector('[data-price-current]');
        this.priceCompare = this.querySelector('[data-price-compare]');
        this.priceBadge = this.querySelector('[data-price-badge]');
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.quantityInput = this.querySelector('[data-quantity-input]');

        this.optionButtons.forEach((button) => {
          button.addEventListener('click', () => this.selectOption(button));
        });

        this.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => this.stepQuantity(-1));
        this.querySelector('[data-quantity-increase]')?.addEventListener('click', () => this.stepQuantity(1));
        this.quantityInput?.addEventListener('input', () => this.updateSubmitLabel());

        this.form = this.querySelector('form');
        this.form?.addEventListener('submit', (event) => this.addToCart(event));
      }

      // Adds via the cart API and slides the mini cart open. If the mini cart
      // isn't on the page, or the request fails, fall back to a normal form
      // submit (which lands on the cart page). "Buy it now" and the dynamic
      // checkout buttons are left alone so they still go straight to checkout.
      async addToCart(event) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || (event.submitter && event.submitter !== this.submitButton)) return;

        event.preventDefault();
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.submitButton.dataset.addingLabel;

        try {
          const response = await fetch(this.form.action, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(this.form),
          });
          if (!response.ok) throw new Error('Add to cart failed');

          await drawer.refresh();
          drawer.open();
        } catch (error) {
          this.form.submit();
          return;
        }

        this.submitButton.disabled = false;
        this.updateSubmitLabel();
      }

      stepQuantity(delta) {
        if (!this.quantityInput) return;
        const next = Math.max(1, (parseInt(this.quantityInput.value, 10) || 1) + delta);
        this.quantityInput.value = next;
        this.updateSubmitLabel();
      }

      selectOption(button) {
        const position = button.getAttribute('data-option-position');
        this.optionButtons
          .filter((el) => el.getAttribute('data-option-position') === position)
          .forEach((el) => el.classList.remove('is-selected'));
        button.classList.add('is-selected');

        const label = this.querySelector('[data-option-value-label="' + position + '"]');
        if (label) label.textContent = button.getAttribute('data-option-value');

        // Jump the gallery straight from the clicked swatch (when it carries
        // a media id) so the hero image responds immediately, rather than
        // waiting on the variant lookup below (which only works when every
        // variant has its own featured image assigned in Shopify admin).
        const mediaId = button.getAttribute('data-media-id');
        if (mediaId && this.gallery && typeof this.gallery.show === 'function') {
          this.gallery.show(mediaId);
        }

        this.syncVariant();
      }

      getSelectedOptions() {
        // Options with only one possible value don't get a picker rendered
        // (see sections/product.liquid's Liquid), so this can't just read
        // positions off the rendered buttons - it has to account for every
        // option position the product actually has (from the variant data),
        // falling back to that option's single shared value where there's
        // no button for it.
        const totalPositions = this.variants[0] ? this.variants[0].options.length : 0;
        const selected = [];

        for (let i = 0; i < totalPositions; i++) {
          const position = String(i + 1);
          const button = this.optionButtons.find(
            (el) => el.getAttribute('data-option-position') === position && el.classList.contains('is-selected')
          );
          selected.push(button ? button.getAttribute('data-option-value') : this.variants[0].options[i]);
        }

        return selected;
      }

      findVariant() {
        const selected = this.getSelectedOptions();
        if (selected.length === 0) return this.variants[0];
        return this.variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
      }

      syncVariant() {
        const variant = this.findVariant();
        if (!variant) return;

        if (this.variantIdInput) this.variantIdInput.value = variant.id;
        if (this.priceCurrent) this.priceCurrent.textContent = variant.price;

        const onSale = variant.compareAtPriceRaw > variant.priceRaw;
        if (this.priceCompare) {
          this.priceCompare.textContent = variant.compareAtPrice;
          this.priceCompare.hidden = !onSale;
        }
        if (this.priceBadge) {
          if (onSale) {
            const percent = Math.round(
              ((variant.compareAtPriceRaw - variant.priceRaw) / variant.compareAtPriceRaw) * 100
            );
            this.priceBadge.textContent = this.priceBadge.dataset.template.replace('__PERCENT__', percent);
            this.priceBadge.hidden = false;
          } else {
            this.priceBadge.hidden = true;
          }
        }

        if (this.submitButton) this.submitButton.disabled = !variant.available;
        this.updateSubmitLabel(variant);

        if (variant.featuredMediaId && this.gallery && typeof this.gallery.show === 'function') {
          this.gallery.show(String(variant.featuredMediaId));
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }

      updateSubmitLabel(variant) {
        if (!this.submitButton) return;
        const current = variant || this.findVariant();
        if (!current) return;

        if (!current.available) {
          this.submitButton.textContent = this.submitButton.dataset.soldOutLabel;
          return;
        }

        const qty = parseInt(this.quantityInput?.value, 10) || 1;
        const total = current.priceRaw * qty;
        this.submitButton.textContent = this.submitButton.dataset.labelTemplate.replace(
          '__PRICE__',
          this.formatMoney(total)
        );
      }

      formatMoney(cents) {
        const value = (cents / 100).toFixed(2);
        const [dollars, decimals] = value.split('.');
        const withCommas = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        let format = this.moneyFormat;
        if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
          return format.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withCommas);
        }
        if (format.indexOf('amount_with_comma_separator') !== -1) {
          return format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas + '.' + decimals);
        }
        if (format.indexOf('amount_no_decimals') !== -1) {
          return format.replace(/\{\{\s*amount_no_decimals\s*\}\}/, dollars);
        }
        if (format.indexOf('amount') !== -1) {
          return format.replace(/\{\{\s*amount\s*\}\}/, dollars + '.' + decimals);
        }
        return '$' + dollars + '.' + decimals;
      }
    }

    customElements.define('product-info', ProductInfo);
  }

  } catch(e) { console.error(e); }
})();
})();
